import { html, LitElement } from 'lit';

import { cardBodyStyles } from './card.styles';

export class CardBody extends LitElement {
	static override styles = [cardBodyStyles()];

	static override get properties() {
		return {
			slot: { type: String },
		};
	}

	declare slot: string;

	constructor() {
		super();
		// this sets the slot to which the card-body should be assigned inside the card component.
		this.slot = 'body';
	}

	override render() {
		return html`
			<div class="m-card-body">
				<slot></slot>
			</div>
		`;
	}
}

window.customElements.define('m-card-body', CardBody);

declare global {
	interface HTMLElementTagNameMap {
		'm-card-body': CardBody;
	}
}
